import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

// Helper function to get auth headers with Bearer token
const getAuthHeaders = () => {
    const token = localStorage.getItem('accessToken') || localStorage.getItem('token') || localStorage.getItem('adminToken');
    return {
        'Content-Type': 'application/json',
        'accept': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
    };
};

/**
 * Fetch all affiliate users (Admin API)
 * Endpoint: /affiliate-link/admin/all-users
 */
export const getAllAffiliateUsers = async (params = {}) => {
    try {
        const response = await axios.get(`${apiUrlOne}/affiliate-link/admin/all-users`, {
            params,
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching all affiliate users:", error);
        throw error;
    }
};

/**
 * Fetch links & clicks for a specific affiliate user (Admin API)
 * Endpoint: /affiliate-link/links-and-clicks/:userId
 */
export const getAffiliateLinksByUserId = async (userId, params = {}) => {
    try {
        const response = await axios.get(`${apiUrlOne}/affiliate-link/admin/links-and-clicks?userId=${userId}`, {
            params,
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching links for affiliate user ${userId}:`, error);
        throw error;
    }
};

/**
 * Fetch link breakdown for a specific affiliate link (Admin API)
 * Endpoint: /affiliate-link/admin/link-breakdown/:linkId
 */
export const getAffiliateLinkBreakdown = async (linkId, params = {}) => {
    try {
        const response = await axios.get(`${apiUrlOne}/affiliate-link/admin/link-breakdown/${linkId}`, {
            params,
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching link breakdown for link ${linkId}:`, error);
        throw error;
    }
};

/**
 * Update status of an affiliate link (Admin API)
 * Endpoint: PUT /affiliate-link/admin/link/:linkId/status
 * Body: { status: 'active' | 'inactive' | 'suspended' | 'deleted' }
 */
export const updateAffiliateLinkStatus = async (linkId, status) => {
    try {
        const response = await axios.put(`${apiUrlOne}/affiliate-link/admin/link/${linkId}/status`, { status }, {
            headers: getAuthHeaders()
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating status for link ${linkId}:`, error);
        throw error;
    }
};

const affiliateApi = {
    getAllAffiliateUsers,
    getAffiliateLinksByUserId,
    getAffiliateLinkBreakdown,
    updateAffiliateLinkStatus
};

export default affiliateApi;